<template>
  <v-row justify="start">
    <v-dialog
      v-model="d_his"
      persistent
      max-width="600px"
      scrollable
      @click:outside="$emit('close')"
      @keydown.esc="$emit('close')"
    >
      <v-card class="rounded_max hide_overflow" flat>
        <v-toolbar dense flat>
          <h3>{{ title }}</h3>
          <v-spacer></v-spacer>
          <v-btn fab x- small depressed @click="$emit('close')"
            ><v-icon small>mdi-close</v-icon></v-btn
          >
        </v-toolbar>
        <v-card-text class="pb-0 px-1">
          <v-container style="height: max-content">
            <div
              class="d-flex"
              v-for="(history, k) in inventory"
              :key="`${k}-hist`"
            >
              <div class="d-flex flex-column align-center">
                <div class="dot_out"></div>
                <div class="line_graph"></div>
              </div>
              <div class="ml-2" style="flex: 1">
                <v-card outlined class="pa-2 mb-2">
                  <b class="mb-1 bold small_txt">
                    {{
                      $date(history.history.created_at).format(
                        "dddd, DD MMMM YYYY . HH:mm"
                      )
                    }}
                  </b>

                  <div>
                    <div class="d-flex align-start">
                      <v-icon small class="mr-2 mt-1">mdi-link-variant</v-icon>
                      <a
                        :href="history.additional_info.content"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <p class="mb-0 small_txt">Link Content</p>
                      </a>
                    </div>
                    <b class="mt-3 color_default">TELADAN Team Approval</b>
                    <div class="d-flex align-start pb-1">
                      <v-icon small class="mr-2 mt-1"
                        >mdi-progress-clock</v-icon
                      >
                      <v-card flat class="d-flex">
                        <b
                          class="small_txt mb-0 mr-2"
                          :style="`color: ${
                            history.history.approval_admin == 'approved'
                              ? '#006341'
                              : history.history.approval_admin == 'declined'
                              ? '#FE0404'
                              : history.history.approval_admin == 'revision'
                              ? '#B3A369'
                              : '#001A72'
                          }`"
                        >
                          {{ history.history.approval_admin }}
                        </b>
                        <p
                          class="small_txt mb-0"
                          v-if="history.history.notes_admin"
                        >
                          : {{ history.history.notes_admin }}
                        </p>
                      </v-card>
                    </div>
                    <v-divider></v-divider>
                    <b class="mt-3 color_default"
                      >Navigator & Council Approval</b
                    >
                    <div class="d-flex align-start pb-1">
                      <v-icon small class="mr-2 mt-1"
                        >mdi-progress-clock</v-icon
                      >
                      <v-card flat class="d-flex">
                        <b
                          class="small_txt mb-0 mr-2"
                          :style="`color: ${
                            history.history.approval_council == 'approved'
                              ? '#006341'
                              : history.history.approval_council == 'declined'
                              ? '#FE0404'
                              : history.history.approval_council == 'revision'
                              ? '#B3A369'
                              : '#001A72'
                          }`"
                        >
                          {{ history.history.approval_council }}
                        </b>
                        <p
                          class="small_txt mb-0"
                          v-if="history.history.approval_council"
                        >
                          : {{ history.history.approval_council }}
                        </p>
                      </v-card>
                    </div>
                  </div>
                </v-card>
              </div>
            </div>
          </v-container>
        </v-card-text>
        <v-card-actions> </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  components: {},
  name: "historySubmission",
  props: ["d_his", "title", "inventory"],
  methods: {
    closeAndFetch() {
      this.$emit("refetch");
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.dot_out {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: green;
}
.line_graph {
  width: 2px;
  background: green;
  height: 100%;
  margin-top: -5px;
}
</style>